import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';
import { Box } from '@mui/material';
import {
  NavAccordion,
  NavAccordionDetails,
  NavAccordionListItemBox,
  NavAccordionListItemText,
  NavAccordionSummary,
  NavListItemText,
} from '../../Components/StyledComponent';
import CustomIcon from '../../Components/CustomIcon';
import { FlexStartBox } from '../../Components/CustomBox';
import { useDashboard } from '../../Context/DashboardContext';

/**
 * DashboardNavItem
 *
 * Renders a "Dashboard" accordion entry in the sidebar.
 * The sub-menu lists every available dashboard except the currently active one.
 * Clicking a sub-item switches the active dashboard and navigates to its home route.
 *
 * Hidden when the user has access to only one dashboard (nothing to switch to).
 */
function DashboardNavItem({ sidebarOpen, setSidebarOpen, isExpanded, onAccordionChange }) {
  const { availableDashboards, activeDashboard, switchDashboard } = useDashboard();
  const navigate = useNavigate();
  const [isHover, setIsHover] = useState(false);

  const inactiveDashboards = availableDashboards.filter(d => d.key !== activeDashboard);

  if (inactiveDashboards.length === 0) return null;

  const handleSwitch = (dashboard) => {
    switchDashboard(dashboard.key);
    navigate(dashboard.route);
    setSidebarOpen(false);
  };

  const handleAccordionToggle = (event, newExpanded) => {
    onAccordionChange(newExpanded ? 'Dashboard' : false);
    setSidebarOpen(true);
  };

  const ToolTipComponent = sidebarOpen ? Box : Tooltip;

  return (
    <NavAccordion
      expanded={isExpanded}
      isSelected={false}
      onChange={handleAccordionToggle}
    >
      <NavAccordionSummary
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        isExpanded={isExpanded}
        isHover={isHover}
        showExpandIcon={sidebarOpen}
        isSelected={false}
      >
        <ToolTipComponent placement="right" title="Dashboard" zIndex={2000}>
          <FlexStartBox>
            <CustomIcon
              name="dashboard-icon"
              isSelected={false}
              style={{ display: 'flex', justifyContent: 'center', fontSize: 19, height: '24px' }}
            />
            {sidebarOpen && (
              <NavListItemText isSelected={false}>Dashboard</NavListItemText>
            )}
          </FlexStartBox>
        </ToolTipComponent>
      </NavAccordionSummary>
      <NavAccordionDetails>
        {inactiveDashboards.map((dashboard) => (
          <NavAccordionListItemBox
            key={dashboard.key}
            onClick={() => handleSwitch(dashboard)}
          >
            <FlexStartBox sx={{ alignItems: 'center', gap: '8px' }}>
              <NavAccordionListItemText isSelected={false}>
                {dashboard.featureName}
              </NavAccordionListItemText>
            </FlexStartBox>
          </NavAccordionListItemBox>
        ))}
      </NavAccordionDetails>
    </NavAccordion>
  );
}

export default DashboardNavItem;
